import Notify from "vue-notifyjs";
import "./globalAxios";
import "./filtersTemplate";
import VueLoading from 'vuejs-loading-plugin';



import "es6-promise/auto";
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/sass/paper-dashboard.scss";
import "@/assets/css/themify-icons.css";
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';


export default {
  install(Vue) {
    Vue.use(VueLoading, {
      dark: true,
      text: 'Загрузка...',
      loading: false,
      background: 'rgb(255,255,255,0.6)',
    })
  }
}
